import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

import { useRequestForm } from '../../hooks/useRequestForm';
import FormInput from '../../components/ui/FormInput';
import Button from '../../components/ui/Button';
import { ROUTES } from '../../constants/api';
import * as aboutUsService from '../../services/aboutUsService';

import heroImg from '../../assets/hero-wedding.png';
import './MainPage.css';

/* ---- SVG Icons ---- */
const IconPhone = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);

const IconUser = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </svg>
);

const IconCalendar = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
);



const IconAlert = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="12" y1="8" x2="12" y2="12"/>
    <line x1="12" y1="16" x2="12.01" y2="16"/>
  </svg>
);

const IconMenu = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="12" x2="21" y2="12"/>
    <line x1="3" y1="6" x2="21" y2="6"/>
    <line x1="3" y1="18" x2="21" y2="18"/>
  </svg>
);

const IconCheck = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

const IconSend = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <line x1="22" y1="2" x2="11" y2="13"/>
    <polygon points="22 2 15 22 11 13 2 9 22 2"/>
  </svg>
);

const IconLayers = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polygon points="12 2 2 7 12 12 22 7 12 2"/>
    <polyline points="2 17 12 22 22 17"/>
    <polyline points="2 12 12 17 22 12"/>
  </svg>
);

const IconUsersRound = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M18 21a8 8 0 0 0-16 0"/>
    <circle cx="10" cy="8" r="5"/>
    <path d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-1.09"/>
  </svg>
);

const IconShield = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
);

const IconMapPin = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);

const IconMailSmall = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);

const IconMessage = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
  </svg>
);

const IconParty = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5.8 11.3L2 22l10.7-3.8"/>
    <path d="M4 3h.01"/>
    <path d="M22 8h.01"/>
    <path d="M15 2h.01"/>
    <path d="M22 20l-3.5-3.5"/>
    <path d="M22 5L8 19l-4 1 1-4L19 5"/>
  </svg>
);

const IconUsersGroup = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

const IconGridDots = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="3" width="7" height="7"/>
    <rect x="14" y="3" width="7" height="7"/>
    <rect x="14" y="14" width="7" height="7"/>
    <rect x="3" y="14" width="7" height="7"/>
  </svg>
);

const IconSmile = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="10"/>
    <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
    <line x1="9" y1="9" x2="9.01" y2="9"/>
    <line x1="15" y1="9" x2="15.01" y2="9"/>
  </svg>
);

/* Service row icons (stroke, sits on tinted circle via CSS) */
const SvcIconWedding = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
  </svg>
);
const SvcIconGift = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="20 12 20 22 4 22 4 12"/>
    <rect x="2" y="7" width="20" height="5"/>
    <line x1="12" y1="22" x2="12" y2="7"/>
    <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>
    <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>
  </svg>
);
const SvcIconBuilding = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="4" y="2" width="16" height="20" rx="2" ry="2"/>
    <path d="M9 22v-4h6v4"/>
    <path d="M8 6h.01"/><path d="M16 6h.01"/><path d="M12 6h.01"/>
    <path d="M12 10h.01"/><path d="M12 14h.01"/>
    <path d="M16 10h.01"/><path d="M16 14h.01"/>
    <path d="M8 10h.01"/><path d="M8 14h.01"/>
  </svg>
);
const SvcIconMoon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
  </svg>
);
const SvcIconBaby = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="8" r="5"/>
    <path d="M8 14s2 3 4 3 4-3 4-3"/>
    <path d="M9 8h.01"/><path d="M15 8h.01"/>
  </svg>
);
const SvcIconHandshake = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M11 12h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 14"/>
    <path d="M7 18h1c.5 0 1-.2 1.4-.6l4.6-5.4"/>
    <path d="M8 12l-2.6 2.6c-.8.8-1.5 1.7-2 2.7"/>
    <path d="M10.7 14.7L16 9.3l2.3 2.3a2 2 0 0 1 .6 1.4V17a2 2 0 0 1-2 2h-2c-1.1 0-2.1-.4-2.8-1.2l-2.9-2.8"/>
  </svg>
);
const SvcIconWine = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M8 22h8"/><path d="M12 11v11"/><path d="M12 11c3.3 0 6-2.7 6-6V3H6v2c0 3.3 2.7 6 6 6z"/>
  </svg>
);
const SvcIconSparkles = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/>
    <path d="M20 3v4"/><path d="M22 5h-4"/>
  </svg>
);

/* ---- Service data ---- */
const SERVICES = [
  { Icon: SvcIconWedding, title: 'Nikoh to\'yi', desc: 'Hayotingizdagi eng muhim kunni unutilmas qilish uchun to\'liq tashkilot xizmati.' },
  { Icon: SvcIconGift, title: 'Tug\'ilgan kun', desc: 'Bolalar va kattalar uchun quvnoq va rang-barang bayram tashkil etamiz.' },
  { Icon: SvcIconBuilding, title: 'Korporativ tadbirlar', desc: 'Kompaniya yig\'ilishlari, konferensiyalar va korporativ kechalar.' },
  { Icon: SvcIconMoon, title: 'Sunnat to\'yi', desc: 'An\'anaviy va zamonaviy uslubda sunnat to\'yi tashkil etish.' },
  { Icon: SvcIconBaby, title: 'Beshik to\'yi', desc: 'Yangi tug\'ilgan chaqaloq sharafiga beshik to\'yi bayramini rejalashtirish.' },
  { Icon: SvcIconHandshake, title: 'Fotiha / Unashtiruv', desc: 'Fotiha va unashtiruv marosimlarini professional tashkil etish.' },
  { Icon: SvcIconWine, title: 'Yubiley', desc: 'Hayotiy sanalarni tantanali tarzda nishonlash xizmati.' },
  { Icon: SvcIconSparkles, title: 'Boshqa tadbirlar', desc: 'Har qanday marosim va tadbirlarni sizning xohishingizga ko\'ra tashkil etamiz.' },
];

/* ==============================================================
   MAIN PAGE
   ============================================================== */
export default function MainPage() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const formRef = useRef(null);

  const {
    form, dbEvents, isLoadingEvents, errors, globalError, isLoading, isSuccess,
    handleChange, handleToggleEvent, handleToggleDateClear, handleSubmit, resetSuccess,
  } = useRequestForm();

  const [eventsDropdownOpen, setEventsDropdownOpen] = useState(false);
  const eventsDropdownRef = useRef(null);

  const [aboutItems, setAboutItems] = useState([]);
  const [loadingAbout, setLoadingAbout] = useState(false);

  useEffect(() => {
    let active = true;
    const fetchAbout = async () => {
      setLoadingAbout(true);
      try {
        const data = await aboutUsService.getAllAboutUs();
        if (active) {
          setAboutItems(Array.isArray(data) ? data : []);
        }
      } catch (err) {
        console.error('Failed to load About Us details:', err);
      } finally {
        if (active) {
          setLoadingAbout(false);
        }
      }
    };
    fetchAbout();
    return () => { active = false; };
  }, []);

  // Click outside listener to close event types dropdown
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (eventsDropdownRef.current && !eventsDropdownRef.current.contains(e.target)) {
        setEventsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  /* Navbar scroll effect */
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setMenuOpen(false);
  };

  return (
    <>
      {/* ======== Navbar ======== */}
      <nav className={`main-nav ${scrolled ? 'main-nav--scrolled' : ''}`} id="main-nav">
        <Link to={ROUTES.MAIN} className="main-nav__brand">
          <div className="main-nav__logo" aria-hidden="true">U</div>
          <span className="main-nav__name">Uday</span>
        </Link>

        <button
          className="main-nav__toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <IconMenu />
        </button>

        <ul className={`main-nav__links ${menuOpen ? 'main-nav__links--open' : ''}`}>
          <li>
            <button type="button" className="main-nav__link" onClick={scrollToForm}>
              <span className="main-nav__link-inner"><IconSend /> So&apos;rov yuborish</span>
            </button>
          </li>
          <li>
            <a href="#services" className="main-nav__link" onClick={() => setMenuOpen(false)}>
              <span className="main-nav__link-inner"><IconLayers /> Xizmatlar</span>
            </a>
          </li>
          <li>
            <a href="#about-us" className="main-nav__link" onClick={() => setMenuOpen(false)}>
              <span className="main-nav__link-inner"><IconUsersRound /> Biz haqimizda</span>
            </a>
          </li>
          <li>
            <Link to={ROUTES.LOGIN} className="main-nav__link main-nav__link--cta">
              <span className="main-nav__link-inner"><IconShield /> Admin</span>
            </Link>
          </li>
        </ul>
      </nav>

      {/* ======== Hero ======== */}
      <section className="hero" id="hero">
        <div className="hero__bg" style={{ backgroundImage: `url(${heroImg})` }} />
        <div className="hero__overlay" />
        <div className="hero__content">
          <div className="hero__badge">
            <span className="hero__badge-dot" />
            Buyurtmalar qabul qilinmoqda
          </div>
          <h1 className="hero__title">
            Sizning <em>bayramingiz</em> — bizning <em>mas'uliyatimiz</em>
          </h1>
          <p className="hero__subtitle">
            To'y, yubiley, tug'ilgan kun va boshqa barcha tadbirlarni professional
            darajada tashkil etamiz. Sizning xohishingiz — bizning vazifamiz.
          </p>
          <div className="hero__actions">
            <button type="button" className="hero__btn hero__btn--primary" onClick={scrollToForm}>
              <IconSend />
              So&apos;rov qoldiring
            </button>
            <a href="#services" className="hero__btn hero__btn--outline">
              <IconLayers />
              Xizmatlarimiz
            </a>
          </div>
        </div>
      </section>

      {/* ======== Stats ======== */}
      <div className="stats-bar">
        <div className="stat-item">
          <div className="stat-item__icon" aria-hidden="true"><IconParty /></div>
          <div className="stat-item__number">500+</div>
          <div className="stat-item__label">Muvaffaqiyatli tadbirlar</div>
        </div>
        <div className="stat-item">
          <div className="stat-item__icon" aria-hidden="true"><IconUsersGroup /></div>
          <div className="stat-item__number">50+</div>
          <div className="stat-item__label">Professional jamoa</div>
        </div>
        <div className="stat-item">
          <div className="stat-item__icon" aria-hidden="true"><IconGridDots /></div>
          <div className="stat-item__number">8+</div>
          <div className="stat-item__label">Tadbir turlari</div>
        </div>
        <div className="stat-item">
          <div className="stat-item__icon" aria-hidden="true"><IconSmile /></div>
          <div className="stat-item__number">98%</div>
          <div className="stat-item__label">Mijozlar mamnuniyati</div>
        </div>
      </div>

      {/* ======== About Us Section ======== */}
      <section className="section" id="about-us">
        <div className="section__header">
          <span className="section__tag">Biz haqimizda</span>
          <h2 className="section__title">Mukammallik sari intiluvchi jamoamiz</h2>
          <p className="section__subtitle">
            Har bir loyiha va tadbir ortida katta tajriba, mas'uliyat va cheksiz mehr yotadi.
          </p>
        </div>

        <div className="about-us-container">
          {loadingAbout ? (
            <div className="about-loading-placeholder">
              <div className="dashboard-loading__spinner" style={{ margin: '0 auto' }} />
              <p style={{ marginTop: '12px', color: 'var(--clr-text-secondary)' }}>Yuklanmoqda...</p>
            </div>
          ) : aboutItems.length > 0 ? (
            <div className="about-cards-dynamic-grid">
              {aboutItems.map((item, index) => {
                const hasImg = Array.isArray(item.mediaUrls) && item.mediaUrls.length > 0;
                return (
                  <div className="about-dynamic-card" key={item.id || index}>
                    {hasImg && (
                      <div className="about-dynamic-card__img-wrap">
                        <img src={item.mediaUrls[0]} alt={item.title} className="about-dynamic-card__img" />
                      </div>
                    )}
                    <div className="about-dynamic-card__body">
                      <h3 className="about-dynamic-card__title">{item.title}</h3>
                      <p className="about-dynamic-card__text">{item.text}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            /* Premium Fallback Grid */
            <div className="about-cards-fallback-grid">
              <div className="about-fallback-card">
                <div className="about-fallback-card__icon-badge">✨</div>
                <h3 className="about-fallback-card__title">Bizning Missiyamiz</h3>
                <p className="about-fallback-card__text">
                  Har bir mijozimiz uchun unutilmas daqiqalarni taqdim etish, to'y va marosimlarni eng yuqori professional darajada va chin dildan tashkil etish.
                </p>
              </div>

              <div className="about-fallback-card">
                <div className="about-fallback-card__icon-badge">👑</div>
                <h3 className="about-fallback-card__title">Nega Aynan Biz?</h3>
                <p className="about-fallback-card__text">
                  Ko'p yillik tajribaga ega bo'lgan professional jamoa, eksklyuziv dizayn, har bir detalga bo'lgan cheksiz e'tibor va mukammal tashkiliy nazorat.
                </p>
              </div>

              <div className="about-fallback-card">
                <div className="about-fallback-card__icon-badge">🤝</div>
                <h3 className="about-fallback-card__title">Kafolatlangan Sifat</h3>
                <p className="about-fallback-card__text">
                  Ishonchli hamkorlar tarmog'i, zamonaviy uskunalar, mazali milliy hamda Yevropa taomlari va kelishilgan vaqtda ideal tarzda o'tuvchi dasturlar.
                </p>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* ======== Services ======== */}
      <section className="section section--warm" id="services">
        <div className="section__header">
          <span className="section__tag">Xizmatlar</span>
          <h2 className="section__title">Barcha turdagi tadbirlar uchun</h2>
          <p className="section__subtitle">
            Nikoh to'yidan beshik to'yigacha — har qanday bayramingizni
            mukammal tashkil etamiz.
          </p>
        </div>
        <div className="services-grid">
          {SERVICES.map((s, i) => (
            <div className="service-card" key={s.title}>
              <div className="service-card__icon" aria-hidden="true">
                <s.Icon />
              </div>
              <h3 className="service-card__title">{s.title}</h3>
              <p className="service-card__desc">{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ======== Request Form ======== */}
      <section className="section" id="request-form" ref={formRef}>
        <div className="section__header">
          <span className="section__tag">So'rov</span>
          <h2 className="section__title">Tadbir uchun so'rov qoldiring</h2>
          <p className="section__subtitle">
            Quyidagi formani to'ldiring va biz siz bilan tez orada bog'lanamiz.
          </p>
        </div>

        <div className="request-section">
          {isSuccess ? (
            <div className="request-success">
              <div className="request-success__icon"><IconCheck /></div>
              <h3 className="request-success__title">So'rov yuborildi!</h3>
              <p className="request-success__text">
                Rahmat! Sizning so'rovingiz qabul qilindi.<br />
                Mutaxassislarimiz tez orada siz bilan bog'lanadi.
              </p>
              <Button variant="primary" size="md" onClick={resetSuccess}>
                Yangi so'rov yuborish
              </Button>
            </div>
          ) : (
            <form className="request-form" onSubmit={handleSubmit} noValidate id="request-submit-form">
              {globalError && (
                <div className="request-error" role="alert">
                  <IconAlert /> {globalError}
                </div>
              )}

              <div className="request-form__grid">
                {/* Full name */}
                <div>
                  <FormInput
                    id="req-fullName"
                    name="fullName"
                    label="Ism Familiya"
                    value={form.fullName}
                    onChange={handleChange}
                    placeholder="To'liq ismingiz"
                    error={errors.fullName}
                    disabled={isLoading}
                    iconLeft={<IconUser />}
                  />
                </div>

                {/* Phone */}
                <div>
                  <FormInput
                    id="req-phone"
                    name="phone"
                    label="Telefon raqam"
                    type="tel"
                    value={form.phone}
                    onChange={handleChange}
                    placeholder="+998 90 123 45 67"
                    error={errors.phone}
                    disabled={isLoading}
                    autoComplete="tel"
                    iconLeft={<IconPhone />}
                  />
                </div>

                {/* Event type dropdown */}
                <div className="request-form__full request-events-wrapper" ref={eventsDropdownRef}>
                  <label className="form-select__label">Tadbir turlari (Kamida bitta tanlang)</label>
                  
                  <div className="custom-multiselect">
                    <button
                      type="button"
                      className={`custom-multiselect__trigger ${eventsDropdownOpen ? 'custom-multiselect__trigger--open' : ''}`}
                      onClick={() => setEventsDropdownOpen(!eventsDropdownOpen)}
                      disabled={isLoading || isLoadingEvents}
                    >
                      <span className="custom-multiselect__trigger-icon" aria-hidden="true">
                        <IconCalendar />
                      </span>
                      <span className="custom-multiselect__trigger-text">
                        {isLoadingEvents ? (
                          'Tadbirlar yuklanmoqda...'
                        ) : form.eventIds.length === 0 ? (
                          'Tadbirlarni tanlang...'
                        ) : (
                          dbEvents
                            .filter((ev) => form.eventIds.includes(ev.id))
                            .map((ev) => ev.title)
                            .join(', ')
                        )}
                      </span>
                      <span className={`custom-multiselect__chevron ${eventsDropdownOpen ? 'custom-multiselect__chevron--rotated' : ''}`}>
                        <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
                          <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </span>
                    </button>

                    {eventsDropdownOpen && !isLoadingEvents && (
                      <div className="custom-multiselect__panel">
                        {dbEvents.map((event) => {
                          const isSelected = form.eventIds.includes(event.id);
                          return (
                            <div
                              key={event.id}
                              className={`custom-multiselect__option ${isSelected ? 'custom-multiselect__option--selected' : ''}`}
                              onClick={() => handleToggleEvent(event.id)}
                            >
                              <input
                                type="checkbox"
                                className="custom-multiselect__checkbox"
                                checked={isSelected}
                                onChange={() => {}}
                              />
                              <span className="custom-multiselect__label">{event.title}</span>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                  {errors.eventIds && <p className="request-events-error">{errors.eventIds}</p>}
                </div>

                {/* Event date & clear toggle */}
                <div className="request-form__full">
                  <FormInput
                    id="req-eventDate"
                    name="eventDate"
                    label="Tadbir sanasi"
                    type="date"
                    value={form.eventDate}
                    onChange={handleChange}
                    error={errors.eventDate}
                    disabled={isLoading || !form.isEventDateClear}
                    iconLeft={<IconCalendar />}
                  />
                  <div className="request-date-clear-wrap">
                    <input
                      type="checkbox"
                      id="req-dateNotClear"
                      className="request-date-clear-cb"
                      checked={!form.isEventDateClear}
                      onChange={handleToggleDateClear}
                      disabled={isLoading}
                    />
                    <label htmlFor="req-dateNotClear" className="request-date-clear-label">
                      Sana hali aniq emas
                    </label>
                  </div>
                </div>

                {/* Message */}
                <div className="request-form__full form-textarea-group">
                  <label htmlFor="req-text" className="form-textarea__label">
                    <IconMessage />
                    <span>Qo'shimcha xabar / batafsil ma'lumot</span>
                  </label>
                  <textarea
                    id="req-text"
                    name="text"
                    value={form.text}
                    onChange={handleChange}
                    placeholder="Qo'shimcha ma'lumot yoki xohishlaringiz..."
                    disabled={isLoading}
                    className={`form-textarea__field ${errors.text ? 'form-textarea__field--error' : ''}`}
                    rows={4}
                  />
                  {errors.text && <p className="request-events-error">{errors.text}</p>}
                </div>
              </div>

              <Button
                id="request-submit-btn"
                type="submit"
                variant="primary"
                size="lg"
                isLoading={isLoading}
                style={{ width: '100%' }}
              >
                {isLoading ? 'Yuborilmoqda...' : 'So\'rov yuborish'}
              </Button>
            </form>
          )}
        </div>
      </section>

      {/* ======== Footer ======== */}
      <footer className="main-footer">
        <div className="main-footer__inner">
          <div>
            <div className="main-footer__brand-name">Uday</div>
            <p className="main-footer__brand-desc">
              Barcha turdagi tadbirlarni professional darajada
              tashkil etish xizmati. Sifat va ishonch.
            </p>
          </div>
          <div>
            <div className="main-footer__col-title">Havolalar</div>
            <ul className="main-footer__links">
              <li><a href="#services"><IconLayers /> Xizmatlar</a></li>
              <li><a href="#request-form"><IconSend /> So&apos;rov yuborish</a></li>
              <li><Link to={ROUTES.LOGIN}><IconShield /> Admin panel</Link></li>
            </ul>
          </div>
          <div>
            <div className="main-footer__col-title">Bog'lanish</div>
            <ul className="main-footer__links main-footer__links--contact">
              <li><a href="tel:+998901234567"><IconPhone /> +998 90 123 45 67</a></li>
              <li><a href="mailto:info@uday.uz"><IconMailSmall /> info@uday.uz</a></li>
              <li><span className="main-footer__static-line"><IconMapPin /> Toshkent, O&apos;zbekiston</span></li>
            </ul>
          </div>
        </div>
        <div className="main-footer__bottom">
          © {new Date().getFullYear()} Uday. Barcha huquqlar himoyalangan.
        </div>
      </footer>
    </>
  );
}
